import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';

import { BackendTable } from '@/components/table/BackendTable';
import { UserRoleFilter } from '@/components/table/filters/UserRoleFilter';
import { UserStatusFilter } from '@/components/table/filters/UserStatusFilter';
import { I18N_DE } from '@/i18n/de';
import { User } from '@/modules/api';
import { backendApiUsersFindAllOptions } from '@/modules/api/@tanstack/react-query.gen';
import { i18nSortingFn } from '@/utils/i18nSortingFn';

export const Route = createFileRoute('/_authenticated/_management/administration/benutzerinnen/')({
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: UsersRoute,
});

const columnHelper = createColumnHelper<User>();

const columns = [
  columnHelper.accessor('firstName', {
    header: 'Vorname',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('lastName', {
    header: 'Nachname',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('email', {
    header: 'E-Mail',
    enableColumnFilter: false,
  }),
  columnHelper.accessor('role', {
    header: 'Rolle',
    enableGlobalFilter: false,
    filterFn: 'arrIncludesSome',
    sortingFn: i18nSortingFn(I18N_DE.UserRole),
    cell: (info) => I18N_DE.UserRole[info.getValue()],
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    enableGlobalFilter: false,
    filterFn: 'arrIncludesSome',
    sortingFn: i18nSortingFn(I18N_DE.UserStatus),
    cell: (info) => I18N_DE.UserStatus[info.getValue()],
  }),
] as ColumnDef<User>[];

function UsersRoute() {
  const navigate = Route.useNavigate();

  const { data, isFetching } = useQuery(backendApiUsersFindAllOptions());

  return (
    <BackendTable
      columns={columns}
      getRowId={(row) => row.id}
      data={data}
      isFetching={isFetching}
      fullHeight
      searchInputPlaceholder="Suche nach Vorname, Nachname oder E-Mail"
      subject="Benutzer*innen"
      onClick={(row) =>
        navigate({
          to: '/administration/benutzerinnen/$userId',
          params: { userId: row.id },
        })
      }
      filters={{ role: UserRoleFilter, status: UserStatusFilter }}
    />
  );
}
